<template>
  <svg :width="width" :height="height" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M54.167 2V11H52.167V2H54.167Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.9945 6.61462C8.23611 6.61462 6 8.86359 6 11.6378V63.948C6 66.7223 8.23611 68.9712 10.9945 68.9712H45C45.5523 68.9712 46 69.4215 46 69.977C46 70.5325 45.5523 70.9827 45 70.9827H10.9945C7.13154 70.9827 4 67.8332 4 63.948V11.6378C4 7.75267 7.13154 4.60311 10.9945 4.60311H64.0055C67.8685 4.60311 71 7.75267 71 11.6378V47.8505C71 48.4059 70.5523 48.8562 70 48.8562C69.4477 48.8562 69 48.4059 69 47.8505V11.6378C69 8.86359 66.7639 6.61462 64.0055 6.61462H10.9945Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M39.1667 52.8792H35.8333C35.3731 52.8792 35 53.2545 35 53.7173V57.0699C35 57.5327 35.3731 57.908 35.8333 57.908H39.1667C39.6269 57.908 40 57.5327 40 57.0699V53.7173C40 53.2545 39.6269 52.8792 39.1667 52.8792ZM35.8333 50.8677C34.2685 50.8677 33 52.1435 33 53.7173V57.0699C33 58.6437 34.2685 59.9195 35.8333 59.9195H39.1667C40.7315 59.9195 42 58.6437 42 57.0699V53.7173C42 52.1435 40.7315 50.8677 39.1667 50.8677H35.8333Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.1667 52.8792H18.8333C18.3731 52.8792 18 53.2545 18 53.7173V57.0699C18 57.5327 18.3731 57.908 18.8333 57.908H22.1667C22.6269 57.908 23 57.5327 23 57.0699V53.7173C23 53.2545 22.6269 52.8792 22.1667 52.8792ZM18.8333 50.8677C17.2685 50.8677 16 52.1435 16 53.7173V57.0699C16 58.6437 17.2685 59.9195 18.8333 59.9195H22.1667C23.7315 59.9195 25 58.6437 25 57.0699V53.7173C25 52.1435 23.7315 50.8677 22.1667 50.8677H18.8333Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.1667 39.8044H52.8333C52.3731 39.8044 52 40.1797 52 40.6426V43.9951C52 44.458 52.3731 44.8332 52.8333 44.8332H56.1667C56.6269 44.8332 57 44.458 57 43.9951V40.6426C57 40.1797 56.6269 39.8044 56.1667 39.8044ZM52.8333 37.7929C51.2685 37.7929 50 39.0688 50 40.6426V43.9951C50 45.5689 51.2685 46.8447 52.8333 46.8447H56.1667C57.7315 46.8447 59 45.5689 59 43.9951V40.6426C59 39.0688 57.7315 37.7929 56.1667 37.7929H52.8333Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M39.1667 39.8044H35.8333C35.3731 39.8044 35 40.1797 35 40.6426V43.9951C35 44.458 35.3731 44.8332 35.8333 44.8332H39.1667C39.6269 44.8332 40 44.458 40 43.9951V40.6426C40 40.1797 39.6269 39.8044 39.1667 39.8044ZM35.8333 37.7929C34.2685 37.7929 33 39.0688 33 40.6426V43.9951C33 45.5689 34.2685 46.8447 35.8333 46.8447H39.1667C40.7315 46.8447 42 45.5689 42 43.9951V40.6426C42 39.0688 40.7315 37.7929 39.1667 37.7929H35.8333Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.1667 39.8044H18.8333C18.3731 39.8044 18 40.1797 18 40.6426V43.9951C18 44.458 18.3731 44.8332 18.8333 44.8332H22.1667C22.6269 44.8332 23 44.458 23 43.9951V40.6426C23 40.1797 22.6269 39.8044 22.1667 39.8044ZM18.8333 37.7929C17.2685 37.7929 16 39.0688 16 40.6426V43.9951C16 45.5689 17.2685 46.8447 18.8333 46.8447H22.1667C23.7315 46.8447 25 45.5689 25 43.9951V40.6426C25 39.0688 23.7315 37.7929 22.1667 37.7929H18.8333Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.1667 26.7297H52.8333C52.3731 26.7297 52 27.1049 52 27.5678V30.9203C52 31.3832 52.3731 31.7584 52.8333 31.7584H56.1667C56.6269 31.7584 57 31.3832 57 30.9203V27.5678C57 27.1049 56.6269 26.7297 56.1667 26.7297ZM52.8333 24.7182C51.2685 24.7182 50 25.994 50 27.5678V30.9203C50 32.4941 51.2685 33.7699 52.8333 33.7699H56.1667C57.7315 33.7699 59 32.4941 59 30.9203V27.5678C59 25.994 57.7315 24.7182 56.1667 24.7182H52.8333Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M39.1667 26.7297H35.8333C35.3731 26.7297 35 27.1049 35 27.5678V30.9203C35 31.3832 35.3731 31.7584 35.8333 31.7584H39.1667C39.6269 31.7584 40 31.3832 40 30.9203V27.5678C40 27.1049 39.6269 26.7297 39.1667 26.7297ZM35.8333 24.7182C34.2685 24.7182 33 25.994 33 27.5678V30.9203C33 32.4941 34.2685 33.7699 35.8333 33.7699H39.1667C40.7315 33.7699 42 32.4941 42 30.9203V27.5678C42 25.994 40.7315 24.7182 39.1667 24.7182H35.8333Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.1667 26.7297H18.8333C18.3731 26.7297 18 27.1049 18 27.5678V30.9203C18 31.3832 18.3731 31.7584 18.8333 31.7584H22.1667C22.6269 31.7584 23 31.3832 23 30.9203V27.5678C23 27.1049 22.6269 26.7297 22.1667 26.7297ZM18.8333 24.7182C17.2685 24.7182 16 25.994 16 27.5678V30.9203C16 32.4941 17.2685 33.7699 18.8333 33.7699H22.1667C23.7315 33.7699 25 32.4941 25 30.9203V27.5678C25 25.994 23.7315 24.7182 22.1667 24.7182H18.8333Z"
      fill="#05070F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M69 19.6894H6V15.6664H69V19.6894Z" fill="#05070F" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M23 2V11.0518H21V2H23Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M59.25 71.9885C65.1936 71.9885 70 67.1612 70 61.221C70 55.2809 65.1936 50.4536 59.25 50.4536C53.3064 50.4536 48.5 55.2809 48.5 61.221C48.5 67.1612 53.3064 71.9885 59.25 71.9885ZM59.25 74C66.2916 74 72 68.2787 72 61.221C72 54.1634 66.2916 48.4421 59.25 48.4421C52.2084 48.4421 46.5 54.1634 46.5 61.221C46.5 68.2787 52.2084 74 59.25 74Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M65.6137 56.2406C66.0096 56.628 66.0182 57.2647 65.633 57.6628L56.6402 66.9577L52.8351 62.6456C52.4685 62.2302 52.5062 61.5945 52.9192 61.2258C53.3323 60.8571 53.9643 60.895 54.3309 61.3104L56.7076 64.0037L64.1997 56.26C64.5848 55.8619 65.2179 55.8532 65.6137 56.2406Z"
      fill="#FF0064"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'CalendarUpToDateIllustration',
  props: {
    width: {
      type: Number,
      default: 76,
    },
    height: {
      type: Number,
      default: 76,
    },
  },
};
</script>
